export const setShellVersion = (version: string) => {
	window.nabshell = {
		version: version,
	};
};

export const getShellVersion = (): string => {
	return window.nabshell?.version || 'not-set!!!';
};
